// 10 character themes + standard. Each theme is a complete visual override
// applied via CSS variables on document.body. Themes contain colors, fonts,
// background patterns, and decorative elements.

export const THEMES = {
  standard: {
    name: "Standard",
    emoji: "🎯",
    tagline: "Neo-brutalist classic",
    colors: {
      bg: "#FDFBF7",
      bgAlt: "#FFFFFF",
      text: "#0A0A0A",
      muted: "#737373",
      accent: "#39FF14",      // graffiti green
      accent2: "#FFD600",     // tape yellow
      danger: "#FF3B30",      // red border
      cardBg: "#FFFFFF",
      headerBg: "#FDFBF7",
    },
    font: "'Work Sans', sans-serif",
    bgPattern: "none",
  },
  batman: {
    name: "Batman",
    emoji: "🦇",
    tagline: "I am vengeance.",
    colors: {
      bg: "#0B0B0F",
      bgAlt: "#15151D",
      text: "#F5F5F0",
      muted: "#888",
      accent: "#FFD700",      // gold-yellow
      accent2: "#FFC400",
      danger: "#FFD700",
      cardBg: "#1A1A24",
      headerBg: "#0B0B0F",
    },
    font: "'Bebas Neue', 'Work Sans', sans-serif",
    bgPattern: "radial-gradient(circle at 80% -10%, rgba(255,215,0,0.15) 0%, transparent 50%)",
  },
  spiderman: {
    name: "Spider-Man",
    emoji: "🕷",
    tagline: "Friendly neighborhood.",
    colors: {
      bg: "#0A1A3F",
      bgAlt: "#0F2052",
      text: "#FFFFFF",
      muted: "#A8B5D6",
      accent: "#E62429",       // spidey red
      accent2: "#1E88E5",      // spidey blue
      danger: "#E62429",
      cardBg: "#FFFFFF",
      headerBg: "#0A1A3F",
    },
    font: "'Bangers', 'Work Sans', sans-serif",
    bgPattern: "radial-gradient(circle at 20% 80%, rgba(230,36,41,0.15) 0%, transparent 40%), radial-gradient(circle at 80% 20%, rgba(30,136,229,0.15) 0%, transparent 40%)",
  },
  ironman: {
    name: "Iron Man",
    emoji: "🦾",
    tagline: "I am Iron Man.",
    colors: {
      bg: "#1A0F0F",
      bgAlt: "#2A1515",
      text: "#FFF8E1",
      muted: "#B8A082",
      accent: "#FFB000",       // arc-reactor gold
      accent2: "#E03C0C",      // armor red
      danger: "#E03C0C",
      cardBg: "#3A1F1F",
      headerBg: "#1A0F0F",
    },
    font: "'Orbitron', 'Work Sans', sans-serif",
    bgPattern: "linear-gradient(135deg, rgba(255,176,0,0.05) 0%, transparent 50%, rgba(224,60,12,0.08) 100%)",
  },
  hulk: {
    name: "Hulk",
    emoji: "🟢",
    tagline: "HULK SMASH!",
    colors: {
      bg: "#0B1F0B",
      bgAlt: "#10330F",
      text: "#F0FFE0",
      muted: "#86B070",
      accent: "#7FFF00",       // hulk green
      accent2: "#9C27B0",      // ripped pants purple
      danger: "#9C27B0",
      cardBg: "#1F4012",
      headerBg: "#0B1F0B",
    },
    font: "'Bangers', 'Work Sans', sans-serif",
    bgPattern: "radial-gradient(circle at 50% 0%, rgba(127,255,0,0.12) 0%, transparent 60%)",
  },
  wonderwoman: {
    name: "Wonder Woman",
    emoji: "⚔",
    tagline: "Power. Grace. Wisdom.",
    colors: {
      bg: "#1A0814",
      bgAlt: "#2A1424",
      text: "#FFF8DC",
      muted: "#C8A8B0",
      accent: "#FFD700",       // gold
      accent2: "#DC143C",      // crimson
      danger: "#DC143C",
      cardBg: "#3F1530",
      headerBg: "#1A0814",
    },
    font: "'Cinzel', 'Work Sans', serif",
    bgPattern: "radial-gradient(ellipse at top, rgba(255,215,0,0.1) 0%, transparent 50%)",
  },
  captainamerica: {
    name: "Captain America",
    emoji: "🛡",
    tagline: "I can do this all day.",
    colors: {
      bg: "#0D1B3D",
      bgAlt: "#162857",
      text: "#FFFFFF",
      muted: "#A8B5D6",
      accent: "#D62828",       // shield red
      accent2: "#FFFFFF",      // white
      danger: "#D62828",
      cardBg: "#FFFFFF",
      headerBg: "#0D1B3D",
    },
    font: "'Bebas Neue', 'Work Sans', sans-serif",
    bgPattern: "linear-gradient(90deg, rgba(214,40,40,0.08) 0%, transparent 30%, transparent 70%, rgba(214,40,40,0.08) 100%)",
  },
  thor: {
    name: "Thor",
    emoji: "⚡",
    tagline: "Bring me Thanos!",
    colors: {
      bg: "#0A0E1F",
      bgAlt: "#141832",
      text: "#F5F0DC",
      muted: "#A8B5C8",
      accent: "#C0C0C0",       // silver hammer
      accent2: "#FFD700",      // asgardian gold
      danger: "#7B68EE",
      cardBg: "#1F254F",
      headerBg: "#0A0E1F",
    },
    font: "'Cinzel', 'Work Sans', serif",
    bgPattern: "radial-gradient(circle at 50% 100%, rgba(123,104,238,0.15) 0%, transparent 50%)",
  },
  blackpanther: {
    name: "Black Panther",
    emoji: "🐾",
    tagline: "Wakanda Forever.",
    colors: {
      bg: "#0A0510",
      bgAlt: "#150A20",
      text: "#E8D0FF",
      muted: "#9080A8",
      accent: "#9D4EDD",       // vibranium purple
      accent2: "#C77DFF",
      danger: "#9D4EDD",
      cardBg: "#250F3F",
      headerBg: "#0A0510",
    },
    font: "'Cinzel', 'Work Sans', serif",
    bgPattern: "radial-gradient(circle at 30% 50%, rgba(157,78,221,0.18) 0%, transparent 50%)",
  },
  naruto: {
    name: "Naruto",
    emoji: "🍥",
    tagline: "Believe it!",
    colors: {
      bg: "#1A0F00",
      bgAlt: "#2F1F08",
      text: "#FFF5E0",
      muted: "#C8A878",
      accent: "#FF6F00",       // orange jumpsuit
      accent2: "#FFC107",
      danger: "#FF6F00",
      cardBg: "#3F2F18",
      headerBg: "#1A0F00",
    },
    font: "'Bangers', 'Work Sans', sans-serif",
    bgPattern: "radial-gradient(circle at 80% 80%, rgba(255,111,0,0.15) 0%, transparent 50%)",
  },
  harrypotter: {
    name: "Harry Potter",
    emoji: "⚡",
    tagline: "Yer a wizard.",
    colors: {
      bg: "#1A0F08",
      bgAlt: "#2F1810",
      text: "#F5E6CC",
      muted: "#C8A878",
      accent: "#D4A017",       // gold snitch
      accent2: "#8B0000",      // gryffindor red
      danger: "#8B0000",
      cardBg: "#3F2818",
      headerBg: "#1A0F08",
    },
    font: "'Cinzel', 'Cormorant Garamond', serif",
    bgPattern: "radial-gradient(ellipse at center, rgba(212,160,23,0.1) 0%, transparent 70%)",
  },
};

export const applyTheme = (themeKey) => {
  const t = THEMES[themeKey] || THEMES.standard;
  const root = document.documentElement;
  root.style.setProperty("--bq-bg", t.colors.bg);
  root.style.setProperty("--bq-bg-alt", t.colors.bgAlt);
  root.style.setProperty("--bq-text", t.colors.text);
  root.style.setProperty("--bq-muted", t.colors.muted);
  root.style.setProperty("--bq-accent", t.colors.accent);
  root.style.setProperty("--bq-accent2", t.colors.accent2);
  root.style.setProperty("--bq-danger", t.colors.danger);
  root.style.setProperty("--bq-card-bg", t.colors.cardBg);
  root.style.setProperty("--bq-header-bg", t.colors.headerBg);
  root.style.setProperty("--bq-font", t.font);
  root.style.setProperty("--bq-bg-pattern", t.bgPattern);
  document.body.dataset.theme = themeKey;
};
